import i18n from '../i18n';

export const TrainerSchoolRole = {
    SCHOOL_OWNER: 'SCHOOL_OWNER',
    SCHOOL_CO_OWNER: 'SCHOOL_CO_OWNER',
    MODERATOR: 'MODERATOR',
    TRAINER: 'TRAINER'
};

export const getRoleHierarchy = (role) => {
    const hierarchy = {
        [TrainerSchoolRole.SCHOOL_OWNER]: 4,
        [TrainerSchoolRole.SCHOOL_CO_OWNER]: 3,
        [TrainerSchoolRole.MODERATOR]: 2,
        [TrainerSchoolRole.TRAINER]: 1
    };
    return hierarchy[role] || 0;
};

export const getRoleDisplayName = (role) => {
    const names = {
        [TrainerSchoolRole.SCHOOL_OWNER]: i18n.t('subscription:roles.owner'),
        [TrainerSchoolRole.SCHOOL_CO_OWNER]: i18n.t('subscription:roles.coOwner'),
        [TrainerSchoolRole.MODERATOR]: i18n.t('subscription:roles.moderator'),
        [TrainerSchoolRole.TRAINER]: i18n.t('subscription:roles.trainer')
    };
    return names[role] || role;
};

export const canRemoveTrainer = (currentUserRole, targetTrainerRole) => {
    return getRoleHierarchy(currentUserRole) > getRoleHierarchy(targetTrainerRole);
};

export const canEditTrainerRole = (currentUserRole, targetTrainerRole) => {
    return getRoleHierarchy(currentUserRole) > getRoleHierarchy(targetTrainerRole);
};

export const canAssignRole = (currentUserRole, newRole) => {
    if (newRole === TrainerSchoolRole.SCHOOL_OWNER) return false;
    return getRoleHierarchy(currentUserRole) > getRoleHierarchy(newRole);
};

export const canManageTrainers = (role) => {
    return role === TrainerSchoolRole.SCHOOL_OWNER ||
        role === TrainerSchoolRole.SCHOOL_CO_OWNER ||
        role === TrainerSchoolRole.MODERATOR;
};

export const canInviteTrainers = (role) => {
    return role === TrainerSchoolRole.SCHOOL_OWNER ||
        role === TrainerSchoolRole.SCHOOL_CO_OWNER ||
        role === TrainerSchoolRole.MODERATOR;
};

export const canEditSchoolSettings = (role) => {
    return role === TrainerSchoolRole.SCHOOL_OWNER ||
        role === TrainerSchoolRole.SCHOOL_CO_OWNER;
};

export const canDeleteSchool = (role) => {
    return role === TrainerSchoolRole.SCHOOL_OWNER;
};

export const getAssignableRoles = (currentUserRole) => {
    const hierarchy = getRoleHierarchy(currentUserRole);
    const roles = [];
    if (hierarchy > getRoleHierarchy(TrainerSchoolRole.SCHOOL_CO_OWNER)) {
        roles.push(TrainerSchoolRole.SCHOOL_CO_OWNER);
    }
    if (hierarchy > getRoleHierarchy(TrainerSchoolRole.MODERATOR)) {
        roles.push(TrainerSchoolRole.MODERATOR);
    }
    if (hierarchy > getRoleHierarchy(TrainerSchoolRole.TRAINER)) {
        roles.push(TrainerSchoolRole.TRAINER);
    }
    return roles;
};

export const isOwner = (role) => role === TrainerSchoolRole.SCHOOL_OWNER;
export const isCoOwner = (role) => role === TrainerSchoolRole.SCHOOL_CO_OWNER;
export const isModerator = (role) => role === TrainerSchoolRole.MODERATOR;
export const isTrainer = (role) => role === TrainerSchoolRole.TRAINER;